export default [
    {
      path: "/viewHistory",
      name: "viewHistory",
      meta: {
        title: "观看历史"
      },
      component: () => import("@/views/viewHistory"),
    }
  ];